<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Placa
          |   - {{ parking.plate }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              //-li
                router-link.cursor-pointer(:to="{name: 'dweller.parking.edit', params: {id: parking.id, tower_id: parking.tower_id, unit_id: parking.unit_id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', parking)") Excluir
      .body
        h6.m-b-15
          | {{ parking.model }} - {{ parking.plate }}
          span.badge.badge-default.float-right UNIDADE {{ parking.unit.number }} -&nbsp;
            i.zmdi.zmdi-circle.offline(v-if="parking.status === 'false'")
            i.zmdi.zmdi-circle.online(v-if="parking.status === 'true'")
        .row
          .col-12
            small
              strong VISITANTE:&nbsp;
              | {{ parking.guest_name }}
        .row
          .col-5
            small
              strong GARAGEM:

          .col-7
            small
              strong TORRE:
        .row
          .col-5(v-if="!user.parking_space_for_visitors")
            span.badge.float-left(
              v-for="g in parking.garage",
              :class="{'badge-success': g.id === parking.garage_id, 'badge-default': g.id !== parking.garage_id}"
              style="margin-right: 5px;"
            )
              | {{g.number}}
          .col-5(v-else)
            span.badge.badge-success.float-left(
              style="margin-right: 5px;"
            )
              | {{ parking.garage_number_visitor }}
          .col-7
            small
              | {{ parking.tower.name}}

        .row
          .col-5
            small
              strong DATA INICIAL:

          .col-7
            small
              strong DATA FINAL:
        .row
          .col-5
            | {{ parking.date_go_in }}
          .col-7
            small
              | {{ parking.date_go_out}}

        .row
          .col-5
            small
              strong MORADOR:

          .col-7
            small
              strong FONE:
        .row
          .col-5
            img.rounded-circle(
              :src='parking.user.image.url',
              title="parking.user.name",
              alt='avatat'
              v-if="parking.user.image !== null",
              style="width: 50px; height: 50px;"
            )
            img.rounded-circle(åå
              src='/static/images/xs/avatar1.jpg',
              title="parking.user.name",
              alt='avatat'
              v-if="parking.user.image === null"
            )
          .col-7
            small {{ maskPhone(parking.user.phone) }}
            br
            small {{ parking.user.name }}

</template>
<style scoped>
  .online {
    color: #86BB71;
  }
  .offline {
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/tenant/parking/index/components/item.vue